export const messages={
networkError:"Kuna tatizo la kiufundi, jaribu tena"
}